import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Input,
  ComponentFactoryResolver,
  Inject,
  Output,
  EventEmitter,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

// import { EventService } from '../core/services/event.service';
import MetisMenu from 'metismenujs/dist/metismenujs';

// import { AuthenticationService } from '../core/services/auth.service';
import { DOCUMENT } from '@angular/common';
// import { AuthfakeauthenticationService } from '../core/services/authfake.service';
// import { LanguageService } from '../core/services/language.service';

import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { DbService } from '../core/services/db.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PwChangeComponent } from '../pages/pw-change/pw-change.component';
import { AllPushModalComponent } from '../pages/all-push-modal/all-push-modal.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  configData;
  openSwitch = false;

  menu = [
    {
      id: 1,
      label: '재활치료시설',
      subItems: [
        {
          id: 2,
          label: '권역별',
          link: '/rehabilitation-region',
          parentId: 1,
        },
        {
          id: 3,
          label: '연령별',
          link: '/rehabilitation-age',
        },
      ],
    },
    {
      label: '장애인복지관 서비스현황',
      link: '/service-region',
    },
    {
      label: '돌봄 및 생활시설',
      subItems: [
        {
          label: '직업재활시설',
          link: '/vocational',
        },
        {
          label: '주간보호시설',
          link: '/daycare',
        },
        {
          label: '평생대학',
          link: '/extension',
        },
        {
          label: '기타 돌봄 시설',
          link: '/other-facility',
        },
      ],
    },
    {
      label: '보조기기 관련시설',
      link: '/assistive-device',
    },
    {
      label: '교육시설',
      link: '/education',
    },
    {
      label: '프로그램 홍보',
      subItems: [
        {
          label: '프로그램 홍보 게시판',
          link: '/program-board',
        },
        {
          label: '함께한 사람들',
          link: '/with',
        },
      ],
    },
  ];

  constructor(
    // private eventService: EventService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private db: DbService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    document.body.setAttribute('data-sidebar', 'dark');
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      console.log('???');

      document.body.classList.remove('vertical-collpsed');
    }
  }

  ngAfterViewInit() {}

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  scrollable() {
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  /**
   * Logout the user
   */
  logout() {
    this.db.logoutUser().then(() => {
      this.router.navigate(['/account/login']);
    });
  }

  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  open(list, menu) {
    if (list.openSwitch) {
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach(ele => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      return false;
    }
  }

  //  전체푸시전송
  async allPush() {
    // 모달 열기
    const modalRef = await this.modalService.open(AllPushModalComponent, {
      scrollable: true,
      centered: true,
      size: 'lg',
      backdrop: 'static',
    });
  }

  // 비밀번호 변경
  async pwChange() {
    // 모달 열기
    const modalRef = await this.modalService.open(PwChangeComponent, {
      scrollable: true,
      centered: true,
      size: 'lg',
      backdrop: 'static',
    });
  }
}
